module.exports = __webpack_public_path__ + "static/media/use12_ch02.15db2820.png";